import { PRODUCT_MODULES } from '../../presentation/productModules';
import type { PresentationModule } from '../../presentation/types';
import { future } from './content';
import { FutureScene } from './scenes/FutureScene';

export const futureModule: PresentationModule = {
  id: 'future',
  label: 'Growing ecosystem',
  priority: 'structural',
  scenes: [
    { ...future, module: 'future', requiresAny: PRODUCT_MODULES, create: (resolved) => new FutureScene(resolved) },
  ],
};
